import { useState, type ReactNode, type FC } from 'react';
import ArticleListingContext, { type ArticleListingContextProps, type ArticleListingProps } from './ArticleListingContext';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';

interface ArticleListingProviderProps extends ArticleListingProps {
    children: ReactNode;
}

const ArticleListingProvider: FC<ArticleListingProviderProps> = ({
    listing,
    children,
    ...restProps
}) => {
    const activeFiltersInitialValue = getActiveFiltersFromURL(listing.filters);
    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);

    const [page, setPage] = useState(getPageFromURL());

    const providerValue: ArticleListingContextProps = {
        activeFilters,
        setActiveFilters,
        page,
        setPage,
        listing,
        ...restProps,
    };

    return (
        <ArticleListingContext.Provider value={providerValue}>
            {children}
        </ArticleListingContext.Provider>
    );
};

export default ArticleListingProvider;
